/** A form field's validation message, rendered only when there is one — shared by every
 * react-hook-form + zod form in the console so each screen doesn't redefine it. */
export function FieldError({ message }: { message?: string }) {
  if (!message) return null
  return <p className="mt-1 text-xs text-destructive">{message}</p>
}
